import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ProjectMetric {
  id: string;
  name: string;
  status: string;
  solution_type: number | null;
  user_name: string;
  area: string | null;
  organization_id: string | null;
  organization_name: string | null;
  submitted: boolean;
  created_at: string;
  kpi_name: string | null;
  kpi_current_value: string | null;
  kpi_target_value: string | null;
}

const SOLUTION_LABELS: Record<number, string> = {
  1: 'Contenido con IA',
  2: 'Vibecoding',
  3: 'Asistentes/Agentes',
  4: 'Automatizaciones',
  5: 'Análisis de Datos',
};

const STATUS_LABELS: Record<string, string> = {
  ideation: 'Ideación',
  in_progress: 'En Progreso',
  completed: 'Completado',
  paused: 'Pausado',
};

export function useProjectMetrics() {
  const projectsQuery = useQuery({
    queryKey: ['admin-project-metrics'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('participant_projects')
        .select(`
          id, name, status, solution_type, submitted, created_at,
          kpi_name, kpi_current_value, kpi_target_value,
          profiles!participant_projects_user_id_fkey (
            full_name, area, organization_id,
            organizations:organization_id (name)
          )
        `)
        .order('created_at', { ascending: false });
      if (error) throw error;

      return (data ?? []).map((p: any) => ({
        id: p.id,
        name: p.name,
        status: p.status ?? 'ideation',
        solution_type: p.solution_type,
        user_name: p.profiles?.full_name ?? '',
        area: p.profiles?.area ?? null,
        organization_id: p.profiles?.organization_id ?? null,
        organization_name: (p.profiles?.organizations as any)?.name ?? null,
        submitted: p.submitted ?? false,
        created_at: p.created_at,
        kpi_name: p.kpi_name,
        kpi_current_value: p.kpi_current_value,
        kpi_target_value: p.kpi_target_value,
      })) as ProjectMetric[];
    },
  });

  const orgsQuery = useQuery({
    queryKey: ['admin-metrics-orgs'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('organizations')
        .select('id, name, logo_url')
        .order('name');
      if (error) throw error;
      return data ?? [];
    },
  });

  return {
    projects: projectsQuery.data ?? [],
    organizations: orgsQuery.data ?? [],
    isLoading: projectsQuery.isLoading || orgsQuery.isLoading,
    SOLUTION_LABELS,
    STATUS_LABELS,
  };
}
